import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import * as Components from 'layouts/products/min'
import * as Context from '../contexts/root'
import { ButtonSet, Previous, Next } from './Navigation'
import Shim from 'components/Shim'

export default function Preview() {
    const description = 'Mountain Information Network Form'
    const [state] = Context.useService()
    const values = Context.useCurrentValues()
    const schema = Context.useDisplaySchema()
    const username = Context.useUsername()
    const data = React.useMemo(() => Object.assign({ username }, values), [values, username])
    const { ownsObservations } = state.context

    return (
        <React.Fragment>
            <Components.Provider data={data} schema={schema}>
                <Components.Header />
                <Components.Metadata />
                <Components.Map />
                <Components.ObservationsSet />
                <Components.Gallery />
            </Components.Provider>
            <Shim top>
                <ButtonSet>
                    <Previous>
                        {ownsObservations ? (
                            <FormattedMessage
                                description={description}
                                defaultMessage="Modify my report"
                            />
                        ) : (
                            <FormattedMessage
                                description={description}
                                defaultMessage="Modify report"
                            />
                        )}
                    </Previous>
                    <Next>
                        {ownsObservations ? (
                            <FormattedMessage
                                description={description}
                                defaultMessage="Submit my report"
                            />
                        ) : (
                            <FormattedMessage
                                description={description}
                                defaultMessage="Submit observations"
                            />
                        )}
                    </Next>
                </ButtonSet>
            </Shim>
        </React.Fragment>
    )
}
